import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { EducationDto } from "./education-dto";

export class EducationResponseModel extends GlobalResponseObject{
    data?: EducationDto;

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EducationDto){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}